/**
 * Copyright (c) 2019 ООО Код Ускорения Бизнеса - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

import io from 'socket.io-client';
import store from '@/store';
import auth from './auth';

export default {
  connect({ token, userId }) {
    const domain = `${window.location.protocol}//${window.location.host}`;
    const path = '/socket';

    window.$socket = io.connect(domain, {
      path,
      reconnect: true,
      transports: ['websocket', 'polling'],
    });
    window.$socket.on('connect', function () {
      console.log('connect to Socket');
      window.$socket.emit('authentication', { token, userId });

      window.$socket.once('unauthorized', function (err) {
        console.log(err);
        store.dispatch('user/logout', {});
      });

      window.$socket.once('authenticated', function (data) {
        console.log('authenticated [event]');

        store.dispatch('socket/connected');
        auth.fetchUser();

        window.$socket.once('logout', function () {
          store.dispatch('user/logout', {});
        });

        window.$socket.once('disconnect', function () {
          console.log('disconnect [event]');
          store.dispatch('socket/disconnected');
        });

        window.$socket.once('reconnecting', function () {
          store.dispatch('socket/disconnected');
        });
      });
    });
  },
  disconnect() {
    console.log('disconnect to Socket');
    if (window.$socket && window.$socket.connected) {
      window.$socket.disconnect();
    }
    store.dispatch('socket/disconnected');
  },
};
